// This file contains material which is the pre-existing property of Psycle
// Interactive Limited.
// Copyright (c) 2017 Psycle Interactive. All rights reserved.

// Import third party modules
import angular from 'angular';
import webfontloader from 'webfontloader';

const MODULE_NAME = 'webfont';
angular.module(MODULE_NAME, [])

    .factory('webfontService', ($q) => {

      // ---------------------------------------------------------------------- //
      // Methods

      function load() {

        // Setup config
        const WebFontConfig = {
          google: {
            families: [
              'Montserrat:300,400,600,700',
            ],
          },
          active: defer.resolve,
          inactive: defer.resolve,
        };

        // Trigger load
        webfontloader.load(WebFontConfig);
      }

      // ---------------------------------------------------------------------- //
      // Private
      const defer = $q.defer();

      // ---------------------------------------------------------------------- //
      // Public
      const webfontService = {
        load: load,
        ready: defer.promise,
      };
      return webfontService;
    });

export default MODULE_NAME;
